import React from 'react';
import { lazyLoad } from '@react-page/editor';
const Panorama = lazyLoad(() => import('@mui/icons-material/Panorama'));
export const defaultTranslations = {
    pluginName: 'Input',
    pluginDescription: 'Form Input Field.',
    inputLabel: 'Label',
    inputName: 'Name',
    inputColor: 'Color',
    inputDefaultValue: 'Default Value',
    inputType: 'Type',
    inputTypeText: 'Text',
    inputTypeEmail: 'Email',
    inputTypeNumber: 'Number',
    inputTypeDate: 'Date',
    inputTypePhone: 'Phone',
    inputMultiLine: 'Multi Line'
};
export const defaultSettings = {
    Controls: () => React.createElement(React.Fragment, null, " Controls for this plugin were not provided"),
    Renderer: () => React.createElement(React.Fragment, null, "Renderer; for this plugin was not provided "),
    translations: defaultTranslations,
    icon: React.createElement(Panorama, null),
    formFields: [],
    inputDataChange: () => React.createElement(React.Fragment, null, "InputDataChange; for this plugin was not provided "),
};
//# sourceMappingURL=settings.js.map